import React, { FC } from 'react';
import styled from 'styled-components';

const Content = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const Step = styled.div<{ size: number; current: number }>`
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    position: relative;

    &::after {
        width: 100%;
        content: '';
        position: absolute;
        height: 1px;
        background: #a9a9a9;
        top: 21px;
        z-index: -1;

        ${(props) => props.size - 1 === props.current && `width: 50%; left: 0`}
        ${(props) => props.current === 0 && `width: 50%; right: 0`}
    }
`;

const Circle = styled.div<{
    current: boolean;
    stepped: boolean;
    circleSize: number;
    circleColor: string;
    circleTextColor: string;
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: ${(props) => props.circleSize}px;
    height: ${(props) => props.circleSize}px;
    color: ${(props) => props.circleTextColor};
    font-size: 14px;

    ${(props) =>
        props.stepped || props.current
            ? `background: ${props.circleColor};`
            : `background: #a9a9a9;`}
`;

const Identifier = styled.div<{
    current: boolean;
    stepped: boolean;
    textColor: string;
}>`
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
    font-size: 14px;

    ${(props) =>
        props.stepped || props.current
            ? `color: ${props.textColor}; `
            : `color: #999;`}
`;

export interface StepperItem {
    title: string;
}

export interface StepperProps {
    items: StepperItem[];
    selectedIndex: number;
    circleSize?: number;
    textColor?: string;
    circleColor?: string;
    borderCircleColor?: string;
    circleTextColor?: string;
}

const Stepper: FC<StepperProps> = ({
    items,
    selectedIndex,
    circleSize = 42,
    textColor = '#555',
    circleColor = '#47516f',
    circleTextColor = '#fff',
}) => {
    return (
        <Content>
            {items.map((step, index) => {
                const current = index === selectedIndex;
                const stepped = index < selectedIndex;

                return (
                    <Step size={items.length} current={index}>
                        <Circle
                            circleColor={circleColor}
                            circleTextColor={circleTextColor}
                            circleSize={circleSize}
                            current={current}
                            stepped={stepped}
                        >
                            {index + 1}
                        </Circle>
                        <Identifier
                            textColor={textColor}
                            current={current}
                            stepped={stepped}
                        >
                            <span>{step.title}</span>
                        </Identifier>
                    </Step>
                );
            })}
        </Content>
    );
};

export { Stepper };
